<template>
    <el-form-item :label="form.name" :prop="form.model"
                :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
  >
  <el-row style="width:226px">
    <el-col :span="24">
  <d2-icon-select v-model="value[form.model]"  :user-input="true"/>
    </el-col>
  </el-row>
    </el-form-item>
</template>

<script>
export default {
  name: 'SelectIcon',
 data () {
    return {
      key: '',
      formData: {},
      mainValue: ''
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: '100%',
            defaultValue: '',
            required: false,
            dataType: 'string',
            pattern: '',
            placeholder: '',
            customClass: '',
            disabled: false,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val
      }
    }
  },
  methods: {
    onInput (val) {
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    onFocus (val) {
      let that = this
      if (typeof that.form.options.onFocus === 'function') { // 判断是否存在数据改变事件
        that.form.options.onFocus()
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/SelectIcon.vue"
}
</vue-filename-injector>
